/* global axios */

import ApiClient from './ApiClient';

class RealEstateBrokerCommissionRequestsAPI extends ApiClient {
  constructor() {
    super('real_estate_broker_commission_requests', { accountScoped: true });
  }

  confirm(commissionInstallmentId, agreed) {
    return axios.post(`${this.url}/confirm`, {
      commission_installment_id: commissionInstallmentId,
      agreed,
    });
  }

  submitTaxDocument(id, { documentKind, file, onUploadProgress }) {
    const formData = new FormData();
    formData.append('document_kind', documentKind);
    formData.append('file', file);

    return axios.post(`${this.url}/${id}/submit_tax_document`, formData, {
      onUploadProgress,
    });
  }

  downloadTaxDocument(id) {
    return axios.get(`${this.url}/${id}/download_tax_document`);
  }
}

export default new RealEstateBrokerCommissionRequestsAPI();
